import { Link } from '@inertiajs/react'
import { 
  LayoutGrid, 
  Server, 
  AppWindow, 
  Archive, 
  FileText, 
  Settings, 
  Bell,
  Mail,
  Activity
} from 'lucide-react'
import { NavFooter } from '@/components/nav-footer'
import { NavMain } from '@/components/nav-main'
import { NavUser } from '@/components/nav-user'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { 
  dashboardPath, 
  serversPath, 
  auditsPath, 
  mailerSettingsPath,
  emailSignaturesPath
} from '@/routes'
import type { NavItem } from '@/types'
import AppLogo from './app-logo'

const mainNavItems: NavItem[] = [
  {
    title: 'Dashboard',
    href: dashboardPath(),
    icon: LayoutGrid,
  },
  {
    title: 'Servers',
    href: serversPath(),
    icon: Server,
  },
  {
    title: 'Background Jobs',
    href: '/jobs',
    icon: Activity,
    isExternal: true,
  },
  {
    title: 'Audit Log',
    href: auditsPath(),
    icon: FileText,
  },
]

const settingsNavItems: NavItem[] = [
  {
    title: 'Mailer Settings',
    href: mailerSettingsPath(),
    icon: Mail,
  },
  {
    title: 'Email Signatures',
    href: emailSignaturesPath(),
    icon: Settings,
  },
]

export function AppSidebar() {
  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={dashboardPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} />
        <NavMain items={settingsNavItems} label="Settings" />
      </SidebarContent>

      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
